import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function IceSkatingIcon(props: IconProps) {
    return <Icon {...props} iconKey={"ice_skating"}/>
}
